import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

/**
 * Preloads lazy-loaded route modules, but only after the app has had a moment
 * to settle, so the initial navigation and first paint aren't competing with
 * every feature bundle downloading at once (which is what `PreloadAllModules`
 * does immediately after bootstrap).
 *
 * Opt a route out entirely with `data: { preload: false }`.
 */
@Injectable({ providedIn: 'root' })
export class DelayedPreloadStrategy implements PreloadingStrategy {

  /** How long to wait after bootstrap before pulling lazy bundles. */
  private static readonly DELAY_MS = 4000;

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data && route.data['preload'] === false) {
      return of(null);
    }
    return timer(DelayedPreloadStrategy.DELAY_MS).pipe(mergeMap(() => load()));
  }
}
